// extracted by mini-css-extract-plugin
module.exports = {"cardFiles":"productFiles_cardFiles__2V6f_"};